import aboutContent from '@/content/pages/about';
import cookiePolicyContent from '@/content/legal/cookiePolicy';
import tosContent from '@/content/legal/tos';
import privacyContent from '@/content/legal/privacy';
import advertisingContent from '@/content/media/advertising';
import businessHoursContent from '@/content/global/businessHours';

const staticContentMap: Record<string, any> = {
  cookiePolicy: cookiePolicyContent,
  tos: tosContent,
  privacy: privacyContent,
  about: aboutContent,
  radio: advertisingContent.RADIO,
  streaming: advertisingContent.STREAMING,
  smartSpeaker: advertisingContent.SMART_SPEAKER,
  podcasts: advertisingContent.PODCASTS,
  businessHours: businessHoursContent,
};

const content = new Map<string, any>();

const fetchContent = async (key: string, force: boolean = false) => {
  if (content.has(key) && !force) {
    return content.get(key);
  }

  const staticContent = staticContentMap[key];
  if (staticContent) {
    content.set(key, staticContent);
    return staticContent;
  }

  console.warn(`[useStaticContent] No static content found for key: ${key}`);
  return null;
};

const useStaticContent = () => {
  return {
    fetchContent,
    getCache: () => new Map(content),
  };
};

export default useStaticContent;
